import { SVGProps } from 'react';

import { InternalIcon } from '../internal-icon';
import { BitkitIconTypes } from '../types';

const glyph = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.6991 0.36815C11.5497 -0.122716 12.5976 -0.122717 13.4482 0.368149L21.4642 4.9942C22.3148 5.48506 22.8388 6.39222 22.8388 7.37395V16.626C22.8388 17.6078 22.3148 18.5149 21.4642 19.0058L13.4482 23.6318C12.5976 24.1227 11.5497 24.1227 10.6991 23.6319L2.68312 19.0058C1.83255 18.5149 1.30857 17.6078 1.30857 16.626V7.37395C1.30857 6.39222 1.83254 5.48506 2.68312 4.9942L10.6991 0.36815Z"
      fill="#94C748"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.1812 6.09581L6.77651 8.0611C6.30107 8.33438 6.00945 8.83942 6.00945 9.38806V14.617C6.00945 15.1635 6.30279 15.6707 6.77682 15.9441L7.58407 16.4101L11.3062 18.5586C11.7717 18.8271 12.3446 18.8319 12.814 18.5729C12.8225 18.5663 12.8315 18.5602 12.8411 18.5547C13.1755 18.3618 13.4201 18.0524 13.5351 17.6951C13.5819 17.5473 13.6067 17.3913 13.6067 17.2315V15.206L11.6365 14.0693L11.0688 13.7417C10.4456 13.3834 10.0632 12.7208 10.0632 12.0025V6.77359C10.0632 6.56228 10.0966 6.35554 10.1596 6.15987C10.1665 6.13838 10.1737 6.11702 10.1812 6.09581Z"
      fill="#101214"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.8416 5.4414C12.376 5.17286 11.8032 5.16811 11.3338 5.42713C11.3253 5.43372 11.3152 5.44044 11.3056 5.44596C10.9715 5.639 10.7273 5.94824 10.6125 6.30544C10.5658 6.45303 10.5411 6.60894 10.5411 6.76854V8.79402L12.4502 9.89552L13.0791 10.2584C13.7024 10.6167 14.0846 11.2792 14.0846 11.9975V17.2264C14.0846 17.438 14.0511 17.6451 13.9879 17.841C13.9811 17.8622 13.974 17.8833 13.9666 17.9042L17.3713 15.9389C17.8467 15.6656 18.1383 15.1606 18.1383 14.612V9.38302C18.1383 8.83654 17.8449 8.32926 17.3709 8.05584L16.5027 7.5547L12.8416 5.4414Z"
      fill="#101214"
    />
  </svg>
);

export const CodeReviewerIcon = (props: BitkitIconTypes): JSX.Element => (
  <InternalIcon {...props} glyph={glyph} />
);
